import {defineStore} from "pinia";
import {ExperienceEvent} from "@/core/interfaces/experience/ExperienceEvent";
import {experienceApi} from "@/container";
import {Experience} from "@/core/interfaces/experience/Experience";

interface ExperienceStore {
    events: ExperienceEvent[];
    experience: Experience | null;
}

export const useExperienceStore = defineStore('experience', {
    state: (): ExperienceStore => ({
        events: [],
        experience: null,
    }),
    getters: {
        eventByName(state) {
            return (name: string) => state.events.find(event => event.slug === name);
        }
    },
    actions: {
        async fetchEvents() {
            return experienceApi().indexEvents()
                .then(events => {
                    this.events = events;
                    window.ipcRenderer.send('dispatch-experience-events', events);
                });
        },
        async read() {
            return experienceApi().read()
                .then(response => {
                    this.experience = response;
                });
        },
    }
});
